import OverallForm from '../../components/Forms/VerificationForms/OverallForm/OverallForm';
import LocationsForm from '../../components/Forms/VerificationForms/LocationsForm/LocationsForm';
import СharacteristicForm from '../../components/Forms/VerificationForms/СharacteristicForm/CharacteristicForm';

export const listOfTabs = [
  { label: 'Overall', Component: (goToNextStep=()=>{}) => (<OverallForm goToNextStep={goToNextStep}/>) },
  { label: 'locations', Component: (goToNextStep=()=>{}) => (<LocationsForm goToNextStep={goToNextStep}/>) },
  { label: 'age & gender', Component: (goToNextStep=()=>{}) => (<СharacteristicForm goToNextStep={goToNextStep}/>) },
];
